// Ethernet Product Types.

export const ETHERNET_PRODUCT_MANAGED = "ETHERNET_PRODUCT_MANAGED";
export const ETHERNET_PRODUCT_EFM = "ETHERNET_PRODUCT_EFM";
export const ETHERNET_PRODUCT_GEA = "ETHERNET_PRODUCT_GEA";
export const ETHERNET_PRODUCT_PTP = "ETHERNET_PRODUCT_PTP";
